import { getAuth } from 'firebase/auth';

const DASHBOARD_URL = 'https://www.salesridge.co/dashboard.html';

// ==========================================
// SYSTÈME DE VÉRIFICATION D'AUTHENTIFICATION DÉSACTIVÉ
// ==========================================
// Firebase avec persistance LOCAL gère automatiquement l'auth
// Pas besoin de vérifications manuelles qui causent des redirections

export function checkAuthAndRedirect() {
  // Fonction vide - Firebase gère automatiquement l'authentification
  // avec la persistance LOCAL configurée
  return;
}

/**
 * Vérifie que l'utilisateur connecté a le rôle admin (custom claims Firebase).
 * Redirige vers le dashboard si non connecté ou si pas admin.
 * @param {firebase.User} user - Utilisateur Firebase (auth.currentUser)
 * @returns {Promise<boolean>} true si accès autorisé, false sinon (redirection effectuée)
 */
export async function checkAdminAccessAndRedirect(user) {
  if (!user) {
    window.location.href = DASHBOARD_URL;
    return false;
  }
  try {
    const tokenResult = await user.getIdTokenResult();
    if (tokenResult.claims.admin === true) {
      return true;
    }
    window.location.href = DASHBOARD_URL;
    return false;
  } catch (err) {
    console.error('[redirect] Erreur vérification rôle admin:', err);
    window.location.href = DASHBOARD_URL;
    return false;
  }
}

/**
 * Vérifie que l'utilisateur connecté a le rôle admin ou trainer (custom claims Firebase).
 * Redirige vers le dashboard si non connecté ou si ni admin ni trainer.
 * @param {firebase.User} user - Utilisateur Firebase (auth.currentUser)
 * @returns {Promise<boolean>} true si accès autorisé, false sinon (redirection effectuée)
 */
export async function checkAdminOrTrainerAccessAndRedirect(user) {
  if (!user) {
    window.location.href = DASHBOARD_URL;
    return false;
  }
  try {
    const tokenResult = await user.getIdTokenResult();
    const isAdmin = tokenResult.claims.admin === true;
    const isTrainer = tokenResult.claims.trainer === true;
    if (isAdmin || isTrainer) {
      return true;
    }
    window.location.href = DASHBOARD_URL;
    return false;
  } catch (err) {
    console.error('[redirect] Erreur vérification rôle admin/trainer:', err);
    window.location.href = DASHBOARD_URL;
    return false;
  }
}